import { render, staticRenderFns } from "./refresh-redirect.vue?vue&type=template&id=a007f158&"
import script from "./refresh-redirect.vue?vue&type=script&lang=js&"
export * from "./refresh-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports